export const URI_TEAM = 'organization/team';
export const URI_TEAM_BIND = `${URI_TEAM}/bind`;
export const URI_TEAM_UNBIND = `${URI_TEAM}/unbind`;
